import React from 'react';
import { Button } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { MenuIcon, XIcon } from '@shopify/polaris-icons';
import { Icon } from "@shopify/polaris";
import { ProfileIcon } from '@shopify/polaris-icons';

const TopBar = ({ isMenuOpen, toggleMenu }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  if (!token) {
    navigate("/login", { replace: true });
    return;
  }
  const decoded = jwtDecode(token);
  const userName = decoded.name;
  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login', { replace: true });
  };
  return (
    <div className="top_bar_section">
      <div className='mobileMenu' onClick={toggleMenu}>
        {isMenuOpen ? (
          <Icon source={XIcon} tone="base" />
        ) : (
          <Icon source={MenuIcon} tone="base" />
        )}
      </div>
      <div className="user-logo">
        <div className='usericon'>
          <Icon source={ProfileIcon} tone="base" />
          <span>{userName}</span>
        </div>
      </div>
      <div className="user-logout">
        <Button variant="primary" onClick={handleLogout}>Log Out</Button>
      </div>
    </div>
  );
};

export default TopBar;
